import { inject, Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { UserService } from './user.service';
import { AccountService } from './account.service';
import { ENVIRONMENT_CONFIG } from '@shared/injection-token/environment-config';
import { AutomationService } from '@shared/services/automation.service';
import { CookieService } from 'ngx-cookie-service';
import { ENVIRONMENT } from '@shared/injection-token/environment';

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  environment = inject(ENVIRONMENT);
  environmentConfig = inject(ENVIRONMENT_CONFIG);
  routesPath = this.environmentConfig.routes;

  constructor(
    private userService: UserService,
    private accountService: AccountService,
    private router: Router,
    private automationService: AutomationService,
    private cookieService: CookieService
  ) {}

  signIn(item: {
    token: string;
    validitySeconds: number;
    param?: {
      key: string;
      value: string;
      currency: string;
    };
    redirectUrl?: string;
  }) {
    localStorage.setItem('token', item.token);
    this.cookieService.set('token', item.token, {
      expires: item.validitySeconds, // 7 jours
      domain: this.environment.production ? `.${this.environmentConfig.host}` : undefined,
      path: '/',
      sameSite: 'Lax',
      secure: this.environment.production,
    });
    this.accountService.getAccount().subscribe((user) => {
      this.userService.setUser(user);
      if (item.param) {
        const price =
          this.environmentConfig.config.subscription.prices.fixed +
          this.environmentConfig.config.subscription.prices.subscription / 2;
        const redirectUrl = item.redirectUrl
          ? item.redirectUrl
          : `/${this.routesPath.loading}?${item.param.key}=${item.param.value}&payment=success&currency=${item.param.currency}&price=${price}&email=${user.email}&firstname=${user.firstname}&lastname=${user.lastname}`;
        if (this.environmentConfig.automation && this.environmentConfig.automation.removeUserToEmailing) {
          this.automationService
            .removeUserToEmailing(this.environmentConfig.automation.removeUserToEmailing, {
              email: user.email,
            })
            .subscribe(
              () => {
                void this.router.navigateByUrl(redirectUrl);
              },
              (err) => {
                void this.router.navigateByUrl(redirectUrl);
              }
            );
        } else {
          void this.router.navigateByUrl(redirectUrl);
        }
      } else {
        void this.router.navigateByUrl(item.redirectUrl ? item.redirectUrl : this.routesPath.dashboard);
      }
    });
  }

  logout(redirect = true) {
    localStorage.removeItem('token');
    this.cookieService.delete('token');
    this.userService.reset();
    if (redirect) {
      void this.router.navigateByUrl('/');
    }
  }

  isSignIn(): boolean {
    return !!localStorage.getItem('token') || !!this.cookieService.get('token');
  }

  getToken() {
    return localStorage.getItem('token') || this.cookieService.get('token');
  }
}
